import type { MediaLogger } from './types';

export const onVideoPlaySymbol = Symbol( 'on-video-play' );
export const mediaLoggerSymbol = Symbol( 'media-logger' );

export type OnVideoPlayProvider = ( videoId: string ) => void;
export type MediaLoggerProvider = MediaLogger;
